// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import axios from 'axios';
import Print from 'vue-print-nb'
//import VueAxios from 'vue-axios';
import Loading from 'vue-loading-overlay';

import 'vue-loading-overlay/dist/vue-loading.min.css';
import 'bootstrap';
import VeeValidate from 'vee-validate';
import zhTWValidate from 'vee-validate/dist/locale/zh_TW';

import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'

import App from './App';
import router from './router';
import './bus';
import currencyFilter from './filters/currency';
import dateFilter from './filters/date';

import { library } from '@fortawesome/fontawesome-svg-core'
import { faFacebookSquare, faInstagram, faFacebookF } from '@fortawesome/free-brands-svg-icons'
import { faShoppingCart } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import { fas } from '@fortawesome/free-solid-svg-icons'
import { far } from '@fortawesome/free-regular-svg-icons'
import { fab } from '@fortawesome/free-brands-svg-icons'



library.add(faShoppingCart, faInstagram, faFacebookSquare, faFacebookF, fas, fab, far);

Vue.component('font-awesome-icon', FontAwesomeIcon);

// require('dotenv').config();

// console.log('env:', process.env);

router.beforeEach(async (to, from, next) => {
  if (to.meta.requiresAuth) {
    var member = JSON.parse(localStorage.getItem('member'));
    if (!member) {
      console.log('local member is not found');
      next({
        path: '/login',
      });
    } else {
      // console.log('i am checking memeber account...')
      var url = `/members/check/` + member.suuid;
      var opt = {
        accessToken: member.accessToken
      }

      await accountsServiceInstance.post(url, opt)
        .then(response => {
          if (response && response.data.success) {
            next()
          } else {
            console.log('member check not found');
            next({
              path: '/login',
            });
          }
        })
        .catch(e => {
          console.error(e);
          console.log('member check fail');
          next({
            path: '/login',
          });
        })
    }
  } else {
    next();
  }
});

Vue.config.productionTip = false;

const Token = process.env.BEARER;
const EC_SERVER = process.env.EC_SERVER;
const ACCOUNT_SERVER= process.env.ACCOUNT_SERVER;


// axios 實例
axios.defaults.withCredentials = true;
const accountsServiceInstance = axios.create({
  baseURL: ACCOUNT_SERVER,
  headers: {
    "Content-Type": "application/json",
    Authorization: `Bearer ${Token}`,
  }
});

const ecServiceInstance = axios.create({
  baseURL: EC_SERVER,
  headers: {
    "Content-Type": "application/json",
    Authorization: `Bearer ${Token}`,
  }
});


const imagesServiceInstance = axios.create({
  baseURL: "https://images-manager-center.appspot.com",
  //baseURL: "https://art0428.ap.ngrok.io",
  headers: {
    "Content-Type": "multipart/form-data",
    Authorization: `Bearer ${Token}`,
  }
});

console.log('process.env.DEFAULT_CAT1:', process.env.DEFAULT_CAT1);
Vue.prototype.$accountsServiceInstance = accountsServiceInstance;
Vue.prototype.$ecServiceInstance = ecServiceInstance;
Vue.prototype.$imagesServiceInstance = imagesServiceInstance;

Vue.prototype.$member = {};

VeeValidate.Validator.localize('zh_TW', zhTWValidate);
Vue.use(VeeValidate);

Vue.use(BootstrapVue)
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin)

Vue.component('Loading', Loading);
Vue.filter('currency', currencyFilter);
Vue.filter('date', dateFilter);

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
});

Vue.use(Print);



// WEBPACK FOOTER //
// ./src/main.js